var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgScreenshare = function SvgScreenshare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22 22",
    xmlSpace: "preserve"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 3H3.1c-.8 0-1.6.7-1.6 1.6V15c0 .9.7 1.6 1.6 1.6V6.2c0-.9.7-1.6 1.6-1.6h13.4c0-.9-.7-1.6-1.6-1.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9 6.1H6.4c-.9 0-1.6.7-1.6 1.6v9.8c0 .9.7 1.6 1.6 1.6h12.5c.9 0 1.6-.7 1.6-1.6V7.6c0-.9-.8-1.5-1.6-1.5zM6.4 17.3V7.6h12.5v9.8l-12.5-.1z"
  })));
};
export default SvgScreenshare;